import { JSONValue } from '../../types';
import config from './config.json';

// TODO: remove this env var and use configSchema from ConficContext everywhere
export const CONFIG_SCHEMA = 'mbdcm'; // process.env.NEXT_PUBLIC_MBD_CONFIG_SCHEMA;
export const screenConfig: JSONValue = config.screen_config || '{}';

export const DataTableViews = (screenGridId, roleId, reportName, configSchema) =>
  `query MyQuery($role_id: [Int], $screen_grid_id: Int, $report_name: String) {
    ${configSchema}_mbd_roles_to_screen_grid_reports(where: {role_id: {_in: [${roleId}]}, screen_grid_id: {_eq: ${screenGridId}}, report_name: {_eq: "${reportName}"}}) {
      screenGridId:screen_grid_id
      mbdReportConfig:mbd_report_config  {
        reportName:report_name
        reportNameen:report_name_en
        reportNamede:report_name_de
        schemaName:schema_name
        viewName:view_name
        mbdReportColumnConfigs:mbd_report_column_configs  {
          colInternalName:col_internal_name
          colDisplayNamede:col_display_name_de
          colDisplayNameen:col_display_name_en
                 }
      }
    }
  }
`;
